import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3430516162/src/mila_me_frontend_customer/app/[locale]/blogs/[id]/BlogArticleClient.tsx");
